import api from '../api';

const CourseService = {
  async list() {
    const response = await api.get('/courses');
    return response.data?.data || [];
  },

  async listMyEnrollments() {
    const response = await api.get('/courses/my-enrollments');
    return response.data?.data || [];
  },

  async create(payload) {
    const response = await api.post('/courses', payload);
    return response.data;
  },

  async update(courseId, payload) {
    const response = await api.put(`/courses/${courseId}`, payload);
    return response.data;
  },

  async publish(courseId) {
    const response = await api.post(`/courses/${courseId}/publish`);
    return response.data;
  },

  async enroll(courseId) {
    const response = await api.post(`/courses/${courseId}/enroll`);
    return response.data;
  },

  async unenroll(courseId) {
    const response = await api.delete(`/courses/${courseId}/enroll`);
    return response.data;
  },

  async progress(courseId) {
    const response = await api.get(`/courses/${courseId}/progress`);
    return response.data;
  },

  async completeLesson(courseId, lessonId) {
    const response = await api.post(`/courses/${courseId}/lessons/${lessonId}/complete`);
    return response.data;
  },

  async uncompleteLesson(courseId, lessonId) {
    const response = await api.post(`/courses/${courseId}/lessons/${lessonId}/uncomplete`);
    return response.data;
  },

  async submitTask(courseId, lessonId, taskId, payload) {
    const response = await api.post(`/courses/${courseId}/lessons/${lessonId}/tasks/${taskId}/submit`, payload);
    return response.data;
  },

  async submitQuiz(courseId, lessonId, answers) {
    const response = await api.post(`/courses/${courseId}/lessons/${lessonId}/quiz/submit`, { answers });
    return response.data;
  },

  async issueCertificate(courseId) {
    const response = await api.post(`/courses/${courseId}/certificate`);
    return response.data;
  },

  async consultCertificate(referenceId) {
    const response = await api.get(`/courses/certificates/${referenceId}`);
    return response.data;
  },

  async listInstructorSubmissions() {
    const response = await api.get('/courses/submissions/instructor');
    return response.data?.data || [];
  },

  async listAttendanceClassrooms() {
    const response = await api.get('/courses/attendance/classrooms');
    return response.data?.data || [];
  },

  async listClassDiaries(filters = {}) {
    const response = await api.get('/courses/attendance/diaries', { params: filters });
    return response.data?.data || [];
  },

  async createClassDiary(payload) {
    const response = await api.post('/courses/attendance/diaries', payload);
    return response.data?.data || null;
  },

  async updateClassDiary(diaryId, payload) {
    const response = await api.put(`/courses/attendance/diaries/${diaryId}`, payload);
    return response.data?.data || null;
  },

  async deleteClassDiary(diaryId) {
    const response = await api.delete(`/courses/attendance/diaries/${diaryId}`);
    return response.data?.data || null;
  },

  async recordAttendance(classroomId, payload) {
    const response = await api.post(`/courses/attendance/classrooms/${classroomId}`, payload);
    return response.data?.data || [];
  },

  async listAttendance(filters = {}) {
    const response = await api.get('/courses/attendance', { params: filters });
    return response.data?.data || [];
  },
};

export default CourseService;
